import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CustomSelect from "../CustomComponents/CustomSelect";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import { dateTransformation,checkAuthentication } from '../../utils.js'

export default function EditSowDialog({ handleEditCallback, data }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const overtimeRegEx = /^(?!0\d)((?:\d{1,2})|(?:\d{1,2}(?:\.\d{1,2})))$/;
	const [LockedAlert, setAlert] = React.useState(false);
    const [prevSowChoices, setprevSowChoices] = React.useState([]);
    const [costCenterChoices, setCostCenterChoices] = React.useState([]);
    
    const initialValues = {
        MGPT: data.MGPT,
        sowLongName: data.Name,
        sowShortName: data.CommonName,
        weekDayOT: data.OverTimeWeek,
        weekEndOT: data.OverTimeWeekEnd,
        holidayOT: data.OverTimeHoliday,
        sharepointLink: data.Link,
        start: moment.utc(data.StartDate).format("MM/DD/YYYY"),
        end: moment.utc(data.EndDate).format("MM/DD/YYYY"),
        prevSow: data.PreviousSOWID,
        costCenter: data.CostCenterID,
        isActive: data.IsActive ? true : false
    };

    const validFormSchema = Yup.object({
        MGPT: Yup
            .string('Enter a MGPT number name for this SOW')
            .required('MGPT is required'),
        sowLongName: Yup
            .string('Enter a long name for this SOW')
            .required('Long name is required'),
        sowShortName: Yup
            .string('Enter a short name for this SOW')
            .required('Short Name is required'),
        weekDayOT: Yup
            .string('Enter Week Day OT rate')
            .matches(overtimeRegEx, "Please enter a correct percentage")
            .required('Week Day OT rate required'),
        weekEndOT: Yup
            .string('Enter Weekend OT rate')
            .matches(overtimeRegEx, "Please enter a correct percentage")
            .required('Weekend OT rate required'),
        holidayOT: Yup
            .string('Enter Holiday OT rate')
            .matches(overtimeRegEx, "Please enter a correct percentage")
            .required('Holiday OT rate required'),
        sharepointLink: Yup
            .string('Enter a sharepoint link to this SOW')
            .required('Sharepoint link is required'),
        start: Yup
            .date('Enter start date of SOW. mm/dd/yyyy')
            .required('Start date required. mm/dd/yyyy'),
        end: Yup
            .date('Enter end date of SOW. mm/dd/yyyy')
            .required('End date required. mm/dd/yyyy'),
        prevSow: Yup
            .string('Enter the privious SOW to this one'),
        costCenter: Yup
            .string('Enter the costCenter to this one')
            .required('costCenter is required'),
        isActive: Yup
             .boolean()
    })
    
    const onTrigger = React.useCallback((values) => {
        const msg = {
            ID: data.ID,
            MGPT: values.MGPT,
            Name: values.sowLongName,
            CommonName: values.sowShortName,
            OverTimeWeek: parseFloat(values.weekDayOT),
            OverTimeWeekEnd: parseFloat(values.weekEndOT),
            OverTimeHoliday: parseFloat(values.holidayOT),
            Link: values.sharepointLink,
            StartDate: moment.utc(values.start),
            EndDate: moment.utc(values.end),
            PreviousSOWID: values.prevSow,
            CostCenter: values.costCenter,
            IsActive: values.isActive
        };
		 if( ( moment.utc(values.start)>moment.utc(values.end))){
					setAlert(true);
				} else {
        handleEditCallback(msg);        
        handleClose();
        }
    })
	
	const handleAlertClose = () => {
	        setAlert(false);
	    };
	    
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const setprevSow = (json) => {
        let choices = [{ label: `"NO Previous SOW"`, value: 0 }];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setprevSowChoices(choices)
    }

    const setCostCenter = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setCostCenterChoices(choices)
    }

    React.useEffect(() => {
		if (open){
		checkAuthentication();
		}
        if (refresh) {

            fetch(`api/SOW/prevSow/${data.ID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setprevSow(json));

            fetch('/api/cost_center/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setCostCenter(json));

            setRefresh(false);
        }
        
    })

    return (
        <div>
            <Tooltip title="Edit" placement="top-end">
                <IconButton variant="contained" onClick={handleClickOpen}>
                    <BorderColorRoundedIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Edit SOW
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Statement of Work Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <TextField
                                            name="MGPT"
                                            variant="outlined"
                                            id="outlined-LongName"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.MGPT}
                                            error={props.touched.MGPT && Boolean(props.errors.MGPT)}
                                            helperText={props.touched.MGPT && props.errors.MGPT}
                                            label="MGPT"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 400 }}>                                        
                                        <TextField
                                            name="sowLongName"
                                            variant="outlined"
                                            id="outlined-LongName"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.sowLongName}     
                                            error={props.touched.sowLongName && Boolean(props.errors.sowLongName)}
                                            helperText={props.touched.sowLongName && props.errors.sowLongName}
                                            label="SoW IDNum/Name"
                                        />
                                    </FormControl>
                        
                                    <FormControl sx={{ m: 1, width: 200 }}>                                        
                                        <TextField
                                            name="sowShortName"
                                            variant="outlined"
                                            id="outlined-ShortName"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.sowShortName}
                                            error={props.touched.sowShortName && Boolean(props.errors.sowShortName)}
                                            helperText={props.touched.sowShortName && props.errors.sowShortName}
                                            label="SoW Short Name"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 210 }}>
                                        <TextField
                                            name="weekDayOT"
                                            id="outlined-weekDayOT"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.weekDayOT}
                                            error={props.touched.weekDayOT && Boolean(props.errors.weekDayOT)}
                                            helperText={props.touched.weekDayOT && props.errors.weekDayOT}
                                            label="Weekday Overtime Rate"
                                        />
                                    </FormControl>
                        
                                    <FormControl sx={{ m: 1, width: 210 }}>
                                        <TextField
                                            name="weekEndOT"
                                            id="outlined-weekEndOT"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.weekEndOT}
                                            error={props.touched.weekEndOT && Boolean(props.errors.weekEndOT)}
                                            helperText={props.touched.weekEndOT && props.errors.weekEndOT}
                                            label="WeekEnd Overtime Rate"
                                        />
                                    </FormControl>
                        
                                    <FormControl sx={{ m: 1, width: 210 }}>
                                        <TextField
                                            name="holidayOT"
                                            id="outlined-holidayOT"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.holidayOT}
                                            error={props.touched.holidayOT && Boolean(props.errors.holidayOT)}
                                            helperText={props.touched.holidayOT && props.errors.holidayOT}
                                            label="Holiday Overtime Rate"
                                        />
                                    </FormControl>

                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="sharepointLink"
                                            id="outlined-sharepointLink"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.sharepointLink}
                                            error={props.touched.sharepointLink && Boolean(props.errors.sharepointLink)}
                                            helperText={props.touched.sharepointLink && props.errors.sharepointLink}
                                            label="SharePoint Link"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 180 }}>
                                        <TextField
                                            name="start"
                                            id="outlined-start"
                                            type= "date"
                                            value={props.values.start.indexOf("/")>0?dateTransformation(props.values.start):props.values.start}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            error={props.touched.start && Boolean(props.errors.start)}
                                            helperText={props.touched.start && props.errors.start}
                                            label="Start Date"
                                            InputLabelProps={{
												shrink: true,
											}}
                                        />
                                    </FormControl>
                    
                                    <FormControl sx={{ m: 1, width: 180 }}>
                                        <TextField
                                            name="end"
                                            id="outlined-end"
                                             type= "date"
                                             value={props.values.end.indexOf("/")>0?dateTransformation(props.values.end):props.values.end}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            error={props.touched.end && Boolean(props.errors.end)}
                                            helperText={props.touched.end && props.errors.end}
                                            label="End Date"
                                            InputLabelProps={{
												shrink: true,
											}}

                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <InputLabel htmlFor="outlined-prevSow">Previous Statement of Work</InputLabel>
                                        <CustomSelect
                                            name="prevSow"
                                            id="outlined-prevSow"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.prevSow}
                                            error={props.touched.prevSow && Boolean(props.errors.prevSow)}
                                            helperText={props.touched.prevSow && props.errors.prevSow}
                                            options={prevSowChoices}
                                            label="Previous Statement of Work"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <InputLabel htmlFor="outlined-prevSow">Cost Center</InputLabel>
                                        <CustomSelect
                                            name="costCenter"
                                            id="outlined-costCenter"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.costCenter}
                                            error={props.touched.costCenter && Boolean(props.errors.costCenter)}
                                            helperText={props.touched.costCenter && props.errors.costCenter}
                                            options={costCenterChoices}
                                            label="Cost Center"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            label="Active"
                                            control={<Checkbox name="isActive" checked={props.values.isActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    </div>                          
                            </Form>
                        )}
                    </Formik>
                </DialogContent> 
                 <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="Date Alert"
                    aria-describedby="Start Date before the End Date"
                >
                    <DialogTitle id="Date Alert">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {"Start Date should be before the End Date, Please enter different time period"}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>                            
            </Dialog>
        </div>
    );
}
